import React, {Component} from 'react';


class DocTable extends Component {
    constructor(props) {
        super(props);
    }
    render() {


    return(

        <div className="doctable">

            <table className="fl-table" width='550'>
                <thead>
                    <tr>
                        {this.props.headers.map(header=><th key={header.name}>{header.name} </th> )}
                    </tr>
                </thead>
                <tbody>
                {this.props.data!=null? this.props.data.map(data => (<tr key={data.recordId}>
                    {this.props.headers.map(header=>(<td key={data[header.accessor]}>{data[header.accessor]}</td>))}
                </tr>)) : null}

                </tbody>
            </table>
        </div>
        );
    }}


export default DocTable;